module.exports = __webpack_public_path__ + "img/herinnering.efebb708.svg";